import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    LeftThumb,
    RangeSliderWrapper,
    RightThumb,
    SearchButton,
    Slider,
    SliderLeftValue,
    SliderRange,
    SliderRightValue,
    SliderTrack,
} from './MultiRangeSliderStyle';

interface MultiRangeSliderProps {
    min: number;
    max: number;
    setMinValueOfFilter?: Function;
    setMaxValueOfFilter?: Function;
    minValueOfFilter?: number;
    maxValueOfFilter?: number;
}

const MultiRangeSlider: FC<MultiRangeSliderProps> = ({
    min,
    max,
    setMinValueOfFilter,
    setMaxValueOfFilter,
    minValueOfFilter,
    maxValueOfFilter,
}) => {
    const [minVal, setMinVal] = useState(minValueOfFilter);
    const [maxVal, setMaxVal] = useState(maxValueOfFilter);
    const range = useRef<HTMLDivElement>(null);
    const getPercent = (value: number) => Math.round(((value - min) / (max - min)) * 100);
    const { t } = useTranslation();

    useEffect(() => {
        const minPercent = getPercent(minVal);
        const maxPercent = getPercent(maxVal);

        if (range.current) {
            range.current.style.left = `${minPercent}%`;
            range.current.style.width = `${maxPercent - minPercent}%`;
        }
    }, [minVal]);

    useEffect(() => {
        const minPercent = getPercent(minVal);
        const maxPercent = getPercent(maxVal);

        if (range.current) {
            range.current.style.width = `${maxPercent - minPercent}%`;
        }
    }, [maxVal]);

    useEffect(() => {
        if (minValueOfFilter === 0 && maxValueOfFilter === 0) {
            setMinVal(min);
            setMaxVal(max);
        } else {
            setMinVal(minValueOfFilter);
            setMaxVal(maxValueOfFilter);
        }
    }, [min, max]);

    const changeMinVal = (e): void => {
        const value = Math.min(Number(e.target.value), maxVal - 1);
        setMinVal(value);
    };

    const changeMaxVal = (e): void => {
        const value = Math.max(Number(e.target.value), minVal + 1);
        setMaxVal(value);
    };

    const changeValues = () => {
        setMinValueOfFilter(minVal);
        setMaxValueOfFilter(maxVal);
    };

    return (
        <RangeSliderWrapper>
            <LeftThumb
                type="range"
                min={min}
                max={max}
                value={minVal}
                onChange={changeMinVal}
                style={{ zIndex: minVal > max - 100 && '5' }}
            />
            <RightThumb type="range" min={min} max={max} value={maxVal} onChange={changeMaxVal} />
            <Slider>
                <SliderTrack></SliderTrack>
                <SliderRange ref={range}></SliderRange>
                <SliderLeftValue>{minVal}</SliderLeftValue>
                <SliderRightValue>{maxVal}</SliderRightValue>
            </Slider>
            <SearchButton onClick={changeValues}>{t('search')}</SearchButton>
        </RangeSliderWrapper>
    );
};

export default MultiRangeSlider;
